import { NgModule, ModuleWithProviders } from '@angular/core';
import * as guards from 'guards';

@NgModule()
export class GuardsModule {
    static forRoot(): ModuleWithProviders<GuardsModule> {
        return {
            ngModule: GuardsModule,
            providers: [guards.AuthGuard]
        };
    }
}
